import moment from 'moment';

import { createCollectionReducer } from 'reducers/account/collections';

export const TYPE = 'flowVersions';
export default createCollectionReducer(TYPE);

export const selectFlowVersions = (state, { flowId, startTime }) => {
  let startArg;
  if (typeof startTime === 'string') {
    const [number, timeUnit] = startTime.split(' ');
    startArg = moment().subtract({ [timeUnit]: number });
  } else {
    startArg = startTime;
  }

  return (
    state.account.flowVersions &&
    state.account.flowVersions[flowId] &&
    state.account.flowVersions[flowId].versions.filter(({ version }) => {
      return moment(version).isAfter(startArg);
    })
  );
};

export const selectFlowVersionsByDimension = (
  state,
  { flowId, startTime, dimension }
) =>
  selectFlowVersions(state, { flowId, startTime }) &&
  selectFlowVersions(state, { flowId, startTime }).reduce((acc, version) => {
    const { version: versionId } = version;
    const date = moment(versionId).format(
      dimension === 'day' ? 'L' : 'YYYY-MM'
    );
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(version);
    return acc;
  }, {});
